import gql from 'graphql-tag'

export const GET_TESTIMONIAL_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getTestimonialPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        nameEn
        nameKg
        nameRu
        professionEn
        professionKg
        professionRu
      }
    }
  }
`

export const GET_TESTIMONIAL_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getTestimonial (
      data: {
        id: $id
      }
    ) {
      id
      nameEn
      nameKg
      nameRu
      commentEn
      commentKg
      commentRu
      professionEn
      professionKg
      professionRu
      image
    }
  }
`
